var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.8263 39.2909C18.0895 39.5636 17.3526 39.8182 16.5789 40C7.07368 37.7091 0 28.2727 0 18.1818V7.27273L16.5789 0L33.1579 7.27273V18.1818C33.1579 19.8182 32.9553 21.4182 32.6053 23C31.1132 22.2545 29.4184 21.8182 27.6316 21.8182C21.5342 21.8182 16.5789 26.7091 16.5789 32.7273C16.5789 35.2 17.4263 37.4727 18.8263 39.2909ZM29.4737 34.5455V39.9818C29.4737 39.9818 25.8079 40 25.7895 39.9818V34.5455H20.2632V30.9091H25.7895V25.4545H29.4737V30.9091H35V34.5455H29.4737Z","fill":"currentColor"}));
}

Shield.defaultProps = {"width":"35","height":"40","viewBox":"0 0 35 40","fill":"none"};

module.exports = Shield;

Shield.default = Shield;
